import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { IntlProvider } from "react-intl";
import "./assets/styles/app.scss";
import ProtectedPage from "./components/auth/ProtectedPage";
import { selectLanguage } from "./i18n/selectLanguage";
import { ToastContainer } from "react-toastify";
import store from "./store/store";
import { Provider } from "react-redux";
import { ThemeProvider } from "./shared/theme/ThemeContext";

import "react-toastify/dist/ReactToastify.css";

import RegisterPage from "./components/account/register/RegisterPage";
import SettingsPage from "./components/account/SettingsPage";
import ForgotPasswordPage from "./components/account/forgot-password/ForgotPasswordPage";
import ResetPasswordPage from "./components/account/forgot-password/ResetPasswordPage";
import EmailConfirmedPage from "./components/account/register/email-confirmed/EmailConfirmedPage";
import TeamPage from "./components/team/TeamPage";
import InvitationPage from "./components/account/invitation/InvitationPage";
import SubscriptionPage from "./components/account/SubscriptionPage";
import McpServersPage from "./components/mcp-platform/servers/McpServersPage";
import ToolRunsPage from "./components/mcp-platform/tools/ToolRunsPage";
import McpServerDetailsPage from "./components/mcp-platform/server-details/McpServerDetailsPage";
import PublicPlaygroundPage from "./components/mcp-platform/playground-page/PublicPlaygroundPage";
import PlaygroundEmbedPage from "./components/mcp-platform/playground-embed/PlaygroundEmbedPage";
import McpshowcaseWidgetPage from "./widgets/mcpshowcase/McpshowcaseWidgetPage";

const App = () => {
  const { lang, resources } = selectLanguage();

  return (
    <IntlProvider locale={lang} messages={resources} defaultLocale="en">
      <ThemeProvider>
        <Provider store={store}>
          <Router basename="/app">
          <Routes>
            <Route path="/" element={<ProtectedPage />}>
              <Route path="/" element={<McpServersPage />} />

              <Route path="/account" element={<SettingsPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/subscription" element={<SubscriptionPage />} />

              {/* Saved results from the free tools on the marketing site. Read-only: the tools
                  themselves live on /tools, where the SEO value is. */}
              <Route path="/tools" element={<ToolRunsPage />} />

              {/* MCP Servers */}
              <Route path="/mcp-servers" element={<McpServersPage />} />
              <Route
                path="/mcp-servers/:serverId"
                element={<McpServerDetailsPage />}
              />
              <Route
                path="/mcp-servers/:serverId/:tabId"
                element={<McpServerDetailsPage />}
              />

              <Route
                path="/mcp-servers/:playgroundId/embed"
                element={<PlaygroundEmbedPage />}
              />
            </Route>

            <Route
              path="/playground/:playgroundId"
              element={<PublicPlaygroundPage />}
            />

            {/* account */}
            <Route
              path="/forgot-password/:tokenId"
              element={<ResetPasswordPage />}
            />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />

            <Route
              path="/register/email-confirmed"
              element={<EmailConfirmedPage />}
            />

            <Route path="/register" element={<RegisterPage />} />
            <Route
              path="/register/invitation/:invitationId"
              element={<InvitationPage />}
            />

            {/* Widgets */}
            <Route
              path="/widgets/mcpshowcase/:playgroundId"
              element={<McpshowcaseWidgetPage />}
            />

            <Route
              path="*"
              element={
                <main style={{ padding: "1rem 2rem" }}>
                  <h1>Page not found</h1>
                </main>
              }
            />
          </Routes>
          </Router>
        </Provider>
        <ToastContainer position="top-right" />
      </ThemeProvider>
    </IntlProvider>
  );
};

export default App;
